import React from 'react';
import { colors } from '@styleseat/brand';
import { Box } from '@styleseat/ui';
import {
  Stack,
  HeaderText,
  Separator,
} from '../../../../ui';

const Header: React.FC = () => (
  <Stack
    paddingBottom={24}
  >
    <Box
      paddingTop={24}
      paddingX={24}
      paddingBottom={16}
      justifyContent="space-between"
    >
      <HeaderText
        level={2}
        testID="cancel-appointment-modal-header-text"
      >
        Cancel Appointment
      </HeaderText>
    </Box>
    <Separator
      appearance="extrathin"
      color={colors.lightGrey}
      paddingY={0}
    />
  </Stack>
);

export default Header;
